/**
 * G2b/K2 — kanal agaci. Degerler ds'lere `@KANAL` olarak BIREBIR gider; SQL `kanal_grup = @KANAL OR
 * kanal = @KANAL` ile esler. Grup adlari iki matview'in `kanal_grup` CASE'iyle (SQL 140), alt kanal adlari
 * `kanal` CASE'iyle ayni (degismedi). 'Mağaza' hem grup hem kanal adidir; ayni deger, ayni sonuc.
 * S289/K9: 'Kendi Online' (yalniz tur 20 fisleri) ve 'Yemek Kartı' (yalniz tur 2 faturalari) perakende satis
 * tanimiyla (SQL 147) bosaldi, agactan cikti. Eski yer imindeki bu degerler `kanalNormalize`'da taninmaz ve
 * TUM KANALLAR'a (null) duser; gruba eslenmez (grup baska bir kitledir, ekran yanlis veri gosterirdi).
 */
export const KANAL_AGACI: ReadonlyArray<{ grup: string; kanallar: readonly string[] }> = [
  { grup: 'Mağaza', kanallar: [] },
  { grup: 'E-Ticaret', kanallar: ['Trendyol', 'Yemeksepeti', 'Getir'] },
  { grup: 'Kurumsal', kanallar: ['Diğer Kurumsal'] },
];

const GECERLI = new Set(KANAL_AGACI.flatMap((g) => [g.grup, ...g.kanallar]));

/** G2b oncesi gruplar; SQL 140 ile kaynakta E-Ticaret'e birlesti. Eski yer imi/paylasilan baglanti bos acilmasin. */
const ESKI_GRUPLAR = new Map<string, string>([
  ['Pazaryeri', 'E-Ticaret'],
  ['Online', 'E-Ticaret'],
]);

export function kanalGecerliMi(k: string | null): k is string {
  return k !== null && GECERLI.has(k);
}

/** URL degeri -> ds'e gidecek kanal. Eski grup yeni adina cevrilir; agacta olmayan her deger "tum kanallar" (null). */
export function kanalNormalize(k: string | null): string | null {
  if (k === null) return null;
  const yeni = ESKI_GRUPLAR.get(k) ?? k;
  return GECERLI.has(yeni) ? yeni : null;
}

/** Tek kanali grubuna, grubu kendisine esler. Bilinmeyen -> undefined. */
export function kanalGrubu(k: string): string | undefined {
  return KANAL_AGACI.find((g) => g.grup === k || g.kanallar.includes(k))?.grup;
}

const KOMISYONLU = new Set(['E-Ticaret', 'Trendyol', 'Yemeksepeti', 'Getir']);

/** Pazaryeri komisyonu ERP'de yok (G1): not E-Ticaret grubu ya da pazaryeri alt kanali seciliyken basilir. */
export function komisyonNotuGerekirMi(k: string | null): boolean {
  return k !== null && KOMISYONLU.has(k);
}

export const KOMISYON_NOTU = 'E-Ticaret satışlarında pazaryeri komisyonu düşülmedi';

/** Sepet ortalamasi Magaza kanalindan (spec §3): Tumu ya da Magaza secimi. */
export function sepetHesaplanirMi(k: string | null): boolean {
  return k === null || k === 'Mağaza';
}
